<template>
  <div class="crud-rooms-container">
    <div class="crud-rooms-content">
      <CrudDataTable
        :con="con"
        :items="filteredItems"
        :newDisabled="newDisabled"
        :sortBy="sortBy"
        ref="dataTable"
      >
        <template v-slot:owner-name v-if="center">{{
          ownerName + " :"
        }}</template>
        <template v-slot:item.available="{ item }">
          <v-icon :color="item.available ? 'green' : 'red'">
            {{
              item.available
                ? "mdi-check-circle-outline"
                : "mdi-close-circle-outline"
            }}
          </v-icon>
        </template>

        <template v-slot:[`moreActions`]="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon small v-on="on" @click="($event) => goToDetails(item)">
                mdi-information
              </v-icon>
            </template>
            <span>{{ $t("crudCommon.tooltipDetails") }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon @click="openDesks(item)" v-on="on"> mdi-desk </v-icon>
            </template>
            <span>{{ $t("nav.desks") }}</span>
          </v-tooltip>
        </template>

        <template v-slot:dialog-form="{ item }">
          <EditRoomForm
            :con="con"
            :editedItem="item"
            @closed="closeEditDialog"
          />
        </template>
      </CrudDataTable>
    </div>
    <div class="occupation-chart">
      <OccupationChart
        :unavailableResources="unavailableResources"
        :resourcesCount="resourcesCount"
        :filterAvailable="filterAvailable"
        :filterResources="filterResources"
        v-if="resourcesCount !== null && resourcesCount !== 0"
      />
    </div>
  </div>
</template>

<script>
import CrudDataTable from "../CrudDataTable";
import EditRoomForm from "./EditRoomForm";
import CrudRoomsTable from "@/models/crud/CrudRoomsTable";
import { mapGetters, mapActions } from "vuex";
import OccupationChart from "../../../public/booking/overview/subcomponent/OccupationChart.vue";

export default {
  name: "CrudRooms",
  components: {
    CrudDataTable,
    EditRoomForm,
    OccupationChart,
  },
  data() {
    return {
      filterAvailable: "available",
      filterResources: "room",
    };
  },
  props: {
    center: null,
    rooms: null,
  },
  computed: {
    ...mapGetters("roomModule", {
      roomsByCenterId: "getRoomsByCenterId",
      roomsUnavailableByCenter: "getUnavailableRoomsByCenter",
    }),
    ownerName() {
      return this.center.name;
    },
    newDisabled() {
      return !this.center;
    },
    con() {
      const _con = {
        ...CrudRoomsTable,
        crud: {
          indexOf: (item) => {
            return this.rooms.indexOf(item);
          },
          create: (item) => {
            item.center = this.center;
            return this.addRoom(item);
          },
          update: (item) => {
            return this.editRoom(item);
          },
          delete: (item) => {
            return this.deleteRoom(item);
          },
        },
      };
      if (this.center) _con.headers = _con.headers.slice(1);
      return _con;
    },
    filteredItems() {
      if (!this.center) return this.rooms;
      return this.roomsByCenterId(this.center.id);
    },
    sortBy() {
      return this.center ? "name" : "center.name";
    },
    resourcesCount() {
      if (this.center) {
        return this.roomsByCenterId(this.center.id).length;
      } else {
        return null;
      }
    },
    unavailableResources() {
      if (this.center) {
        return this.roomsUnavailableByCenter(this.center).length;
      } else {
        return null;
      }
    },
  },
  methods: {
    ...mapActions("roomModule", ["addRoom", "editRoom", "deleteRoom"]),

    closeEditDialog() {
      this.$refs.dataTable.closeEdit();
    },
    goToDetails(item) {
      this.$router.push({
        name: "admin-details-room",
        params: {
          centerId: item.center.id,
          roomId: item.id,
        },
      });
    },
    openDesks(item) {
      this.$router.push({
        name: "admin-room-desks",
        params: { centerId: item.centerId, roomId: item.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.crud-rooms-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  /* Ajoutez d'autres styles si nécessaire */
}

.crud-rooms-content {
  flex: 1; /* Le composant CrudDataTable prendra tout l'espace disponible */
  /* Ajoutez d'autres styles si nécessaire */
}

.occupation-chart {
  margin-left: 20px; /* Espace entre les deux composants */
  /* Ajoutez d'autres styles si nécessaire */
}

/* Ajoutez d'autres styles pour les composants selon vos besoins */
</style>
